<template>
  <div id="dashboard">
    <div class="block-content-full">
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtn"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <p class="show-on-print print-title">用户意见反馈</p>
                <p
                  class="show-on-print print-subheading"
                >{{ '时间范围： ' + duration.startDate + ' 至 ' + this.duration.endDate }}</p>
                <table
                  id="feedBackList"
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('ID',$event)"
                      >#</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:175px;"
                        @click="getList('COMPANY_NAME',$event)"
                      >来源</th>
                      <th
                        class="text-left sorting d-md-table-cell"
                        style="min-width:100px;"
                        @click="getList('CELL_NAME',$event)"
                      >小区名称</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:95px;"
                        @click="getList('QUESTTYPE',$event)"
                      >问题类型</th>
                      <th
                        class="text-left sorting"
                        style="width: 180px;min-width: 180px;"
                        @click="getList('QUESTION',$event)"
                      >问题描述</th>
                      <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('USER_ID',$event)"
                      >用户ID</th>
                      <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('PHONE',$event)"
                      >手机号码</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:175px;"
                        @click="getList('CREATETIME',$event)"
                      >提交时间</th>
                      <th
                        class="text-center d-xl-table-cell sorting"
                        style="width: 100px; min-width:100px"
                        @click="getList('STATUS',$event)"
                      >状态</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:100px;"
                        @click="getList('DEAL_USER',$event)"
                      >处理人</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:180px;"
                        @click="getList('ANSWER',$event)"
                      >处理意见</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:180px;"
                        @click="getList('DEAL_TIME',$event)"
                      >处理时间</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:180px;"
                        @click="getList('TAKE_TIME',$event)"
                      >耗时</th>
                    </tr>
                  </thead>
                  <tbody v-if="feedBacks.length">
                    <tr v-for="(item, i) in feedBacks" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left d-xl-table-cell">{{ item.COMPANY_NAME }}</td>
                      <td class="text-left d-md-table-cell">{{ item.CELL_NAME }}</td>
                      <td
                        class="text-left d-xl-table-cell"
                        style="min-width:80px;"
                      >{{ showType(item.QUESTTYPE) }}</td>
                      <td class="text-left d-xl-table-cell">
                        <div class="text-over" style="width:180px">{{ item.QUESTION }}</div>
                      </td>
                      <td class="text-left">{{ item.USER_ID }}</td>
                      <td class="text-left">{{ item.PHONE }}</td>
                      <td class="text-left d-xl-table-cell">{{ item.CREATETIME }}</td>
                      <td class="text-center d-xl-table-cell">
                        <li v-show="item.STATUS == '已处理'" class="fa fa-check-circle text-success"></li>
                        <li v-show="item.STATUS == '已忽略'" class="fa fa-minus-circle text-warning"></li>
                      </td>
                      <td class="text-left d-xl-table-cell">{{ item.DEAL_USER }}</td>
                      <td class="text-left d-xl-table-cell">
                        <div class="text-over" style="width:180px">{{ item.ANSWER }}</div>
                      </td>
                      <td class="text-left d-xl-table-cell">{{ item.DEAL_TIME }}</td>
                      <td class="text-left d-xl-table-cell">{{ item.TAKE_TIME }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="14">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="feedBacks && feedBacks.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../../Util.js";
import screenTime from "../../../../components/screenTime";
import pageSize from "../../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      feedBacks: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      clipboard: null,
      sorting: "",
      orderBy: false
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    this.getList();
    this.copy();
    // setTimeout(() => {
    //   $('#feedBackList').DataTable({
    //     scrollX: true,
    //     searching: false,//搜索
    //     info: false,
    //     scrollCollapse: true,
    //     paging: false,
    //     fixedColumns: {
    //         leftColumns: 0,
    //         rightColumns: 1
    //     },
    //     drawCallback: function(){
    //         //重绘的回调执行
    //     }
    // } );
    // }, 1000);
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changePage(val) {
      this.page = val;
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/Feedback/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}&STATUS=0,2`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.feedBacks = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/Feedback/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}&STATUS=0,2`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    },
    showType(str) {
      if (str == "1") {
        return "充电问题";
      } else if (str == "2") {
        return "费用问题";
      } else {
        return "其他问题";
      }
    }
  }
};
</script>
<style lang="less">
.table tr td {
  .green {
    color: #82b54b !important;
  }
  .yellow {
    color: #ffb119 !important;
  }
}
</style>